/* import __COLOCATED_TEMPLATE__ from './bom-source-panes.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();